import { useEffect } from 'react';
import Masonry from 'react-masonry-css'
import M from 'materialize-css/dist/js/materialize.min';
import pic from '../../assets/image-placeholder.jpg';

const CampusImages = () => {

    useEffect(() => {
        var elems = document.querySelectorAll('.materialboxed');
        M.Materialbox.init(elems, {});
    }, []);

    const breakpoints = {
        default: 3,
        600: 2
    }

    return ( 
        <div className="col s12 mt-5 px-5 py-2" id="campus">
            <Masonry
                breakpointCols={breakpoints}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
            >
                {
                    [1,2,3,4,5,6,7,8,9,10].map((item) => (
                        
                        <div key={item}>        
                            <img 
                                src={`/img/gallery/img-${item}.jpg`} 
                                alt="LLC students" 
                                className="materialboxed"
                                onError={(e) => e.target.setAttribute('src', pic)}
                            />
                        </div>
                        
                    ))
                }
              
            </Masonry>
        </div>
     );
}
 
export default CampusImages;